class SizeChart {
	constructor() {
		this.initialize();
	}

	initialize() {
		$(document).on('load', function() {
			$(".js-size-chart__mobile-menu-select").change(function() {
				let val = $(this).val();
				let text = $(this).find('option:selected').text();
				$(".js-size-chart__mobile-menu-span").text(text);
				$(".js-size-chart__content-tab").removeClass("active");
				$("#" + val).addClass("active");
			});
		});
	}
}


export {SizeChart};

$(window).on('load', () => {
	let sizeCharts = [];

	if ($('.size-chart').length > 0) {
		$('.size-chart').each(function(i) {
			sizeCharts[i] = new SizeChart($(this));
			sizeCharts[i].initialize();
		})
	}
});
